import useSWR from 'swr';
import { route } from 'nextjs-routes';
import { useStore } from './use-store';
import FrontendHttpClient from '@/utils/http-handler/frontend-http-client';

/**
 * Returns the division of the currently-selected insured. The insured picker
 * is the de-facto "which division am I working in" control, so the rest of the
 * UI (header badge, default-signature/producer pickers, etc.) reads from here.
 */
export function useCurrentDivision() {
  const [{ insuredId }] = useStore();

  const { data, isValidating } = useSWR(
    insuredId
      ? [route({ pathname: '/api/v2/divisions/current' }), insuredId]
      : null,
    async ([url]) => {
      const res = await FrontendHttpClient.get(url);
      return res.data;
    }
  );

  return {
    currentDivision: data || null,
    isValidating,
  };
}
